import { ContainerModule, interfaces } from 'inversify';
import { IJobDetailsService, JobDetailsService } from './jobDetails.service';
import { IJobDetailsStore, JobDetailsStore } from './jobDetails.store';
import { IJobDetailsFormsBl, JobDetailsFormsBl } from './jobDetailsForms.bl';
import { IJobsService, JobsService } from './jobs.service';
import { IJobsStore, JobsStore } from './jobs.store';
import { IJobThresholdStore, JobThresholdStore } from './jobThreshold.store';
import { IPredictionImagePreviewService, JobPredictionImagesService } from './predictionInspector.service';
import { IPredictionInspectorStore, PredictionInspectorStore } from './predictionInspector.store';
import { IImagesApiService, ImagesApiService } from './services/imagesApi.service';
import { IJobActionsApiService, JobActionsApiService } from './services/jobActionsApi.service';
import { IJobDetailsApiService, JobDetailsApiService } from './services/jobDetailsApi.service';
import { IJobsApiService, JobsApiService } from './services/jobsApi.service';
import { IJobSettingsApiService, JobSettingsApiService } from './services/jobSettingsApi.service';

export const jobsModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IJobDetailsService.$).to(JobDetailsService).inSingletonScope();
  bind(IJobDetailsFormsBl.$).to(JobDetailsFormsBl).inSingletonScope();
  bind(IJobsService.$).to(JobsService).inSingletonScope();
  bind(IPredictionImagePreviewService.$).to(JobPredictionImagesService).inSingletonScope();
  bind(IJobActionsApiService.$).to(JobActionsApiService).inSingletonScope();
  bind(IImagesApiService.$).to(ImagesApiService).inSingletonScope();
  bind(IJobDetailsApiService.$).to(JobDetailsApiService).inSingletonScope();
  bind(IJobSettingsApiService.$).to(JobSettingsApiService).inSingletonScope();
  bind(IJobsApiService.$).to(JobsApiService).inSingletonScope();
  bind(IJobsStore.$)
    .to(JobsStore as interfaces.Newable<IJobsStore>)
    .inSingletonScope();
  bind(IJobDetailsStore.$)
    .to(JobDetailsStore as interfaces.Newable<IJobDetailsStore>)
    .inSingletonScope();
  bind(IPredictionInspectorStore.$).to(PredictionInspectorStore).inSingletonScope();
  bind(IJobThresholdStore.$).to(JobThresholdStore).inSingletonScope();
});
